export * from "./collection-banner.component"